






















import { Prop, Vue, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import DeliveryPoint from '@/dto/deliveries/DeliveryPoint'
import PopupMenu from '@/components/delivery/delivery-points/PopupMenu.vue'
import deliveryPointsStore from '@/stores/DeliveryPointsStore'
import { NotifyHelper } from 'vue-kit'

@Component({
  components: { PopupMenu },
})
export default class PointsTableRow extends Vue {
  @Prop(Object)
  point: DeliveryPoint

  @Prop(Object)
  props: any

  deliveryPointsStore = deliveryPointsStore

  showDeliveryPoint() {
    const pointId = this.point.id as number
    this.$router.replace({ query: { pointId: pointId.toString() } })
  }

  @Watch('point.cardEnabled')
  @Watch('point.codEnabled')
  savePoint() {
    this.deliveryPointsStore
      .saveDeliveryPoint(Object.assign({}, this.point) as DeliveryPoint)
      .then(() => NotifyHelper.success('Пункт выдачи сохранен'))
      .catch(() => NotifyHelper.error('Ошибка сервера!'))
  }
}
